/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */

import { Button, Col, Drawer, Form, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useCallback, useState } from 'react';

interface IProps {
  showFilters: boolean;
  closeFilters: () => void;
  search(start_date: string, end_date: string): void;
}

const LogWebhookCategoryFilters: React.FC<IProps> = props => {
  const { showFilters, closeFilters, search } = props;
  const [filters, setFilters] = useState({
    start_date: '',
    end_date: '',
  });

  const [form] = useForm();

  const onSearch = useCallback(() => {
    const { start_date, end_date } = form.getFieldsValue();

    search(
      start_date === undefined ? '' : start_date,
      end_date === undefined ? '' : end_date,
    );
  }, [form, search]);

  return (
    <Drawer
      title="Filtros de pesquisa"
      placement="right"
      closable={false}
      onClose={closeFilters}
      visible={showFilters}
    >
      <Form layout="vertical" onFinish={onSearch} form={form}>
        <Col span={24}>
          <Form.Item label="Data início" name="start_date"  rules={[
            {
              required: true,
              message: 'Por favor, selecione uma data inicial!',
            },
          ]}>
            <Input
              className="dcs-input"
              allowClear
              type="date"
              onChange={e =>
                setFilters({ ...filters, start_date: e.target.value })
              }
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Data fim" name="end_date"  rules={[
            {
              required: true,
              message: 'Por favor, selecione uma data final!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const startDate = getFieldValue('start_date');
                if (!value || !startDate || new Date(value) >= new Date(startDate)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('A data final não pode ser anterior à data inicial!')
                );
              },
            }),
          ]}>
            <Input
              className="dcs-input"
              allowClear
              type="date"
              onChange={e =>
                setFilters({ ...filters, end_date: e.target.value })
              }
            />
          </Form.Item>
        </Col>
        <Form.Item>
          <Button type="primary" shape="round" htmlType="submit">
            Buscar
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default LogWebhookCategoryFilters;
